import { render } from "./TeamPreferences.vue?vue&type=template&id=61610878&scoped=true"
import script from "./TeamPreferences.vue?vue&type=script&lang=js"
export * from "./TeamPreferences.vue?vue&type=script&lang=js"

import "./TeamPreferences.vue?vue&type=style&index=0&id=61610878&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61610878"]])

export default __exports__